import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { tap, switchMap, map, catchError, mergeMap, flatMap, merge, concatMap } from 'rxjs/operators';
//20250602 axa inici
//import { User, UserAddress } from '../_models';
import { DeliveryReservation, User, UserAddress, UserAxA } from '../_models';
//20250602 axa final
import { environment } from 'src/environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  //20250602 axa inici
  private currentUserAxASubject: BehaviorSubject<UserAxA>;
  public currentUserAxA: Observable<UserAxA>;
  //20250602 axa final

  constructor(
      private http: HttpClient,
      private toastr: ToastrService,
      private router: Router,
      private translate : TranslateService,
      private dom : DomSanitizer
    ) {
      // console.log('init auth');
      if (localStorage.getItem('currentUser')){
        this.currentUserSubject = new BehaviorSubject<User>(new User(JSON.parse(localStorage.getItem('currentUser'))));
        this.currentUserSubject.value.user_addresses.forEach(address => {
          address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
        });       
      } else {
        this.currentUserSubject = new BehaviorSubject<User>(null);
    }
      //20250602 axa inici
      if (localStorage.getItem('currentUserAxA')) {
        this.currentUserAxASubject = new BehaviorSubject<UserAxA>(new UserAxA(JSON.parse(localStorage.getItem('currentUserAxA'))));
        this.currentUserAxASubject.value.user_AxA_addresses.forEach(address => {
          address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
        });
      } else {
        this.currentUserAxASubject = new BehaviorSubject<UserAxA>(null);
      }

      this.currentUser = this.currentUserSubject.asObservable();
      this.currentUserAxA = this.currentUserAxASubject.asObservable();
      //20250602 axa final
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public get isLogedUser() : boolean
  {
    return this.currentUserValue != null;
  }

  login(username: string, password: string) {

    //console.log("login normal");
    return this.http.post<any>(`${environment.API_ENDPOINT}login`, { id_user: username.toLowerCase(), password: password }).pipe(
      concatMap (token => {
          const helper = new JwtHelperService();
          let user = new User();
          user.id_user = username.toLowerCase();
          user.token = token;
          user.payload = helper.decodeToken(user.token);
        
          // get user data
          
          const httpOptions = {
            headers: new HttpHeaders({ Authorization: `Bearer ${token}` })
          };

          return this.http.get<User>(`${environment.API_ENDPOINT}users/${user.id_user}/show`, httpOptions ).pipe(
            concatMap ( usrInfo => {
              Object.assign(user, usrInfo);
              user.id_user = usrInfo.id_user.toLowerCase();
              if (user.user_addresses){
                user.user_addresses = user.user_addresses.map( address => new UserAddress(address));
              }
              user.user_addresses.forEach(address => {
                  address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
              });

              //20250602 axa inici

              // elimina el login de compra AxA
              this.clearStorage();
              this.currentUserAxASubject.next(null);

              // guarda el login de compra planificada
              localStorage.setItem('currentUser', JSON.stringify(user));
              this.currentUserSubject.next(user);

              this.translate.use(user.language);
              this.toastr.success(this.translate.instant('LOGIN.LOGEDIN'));

              // save to storage
              //localStorage.setItem('currentUser', JSON.stringify(user));
              //this.currentUserSubject.next(user);
              //this.translate.use(user.language);
              //this.toastr.success(this.translate.instant('LOGIN.LOGEDIN'));

              //20250602 axa final
              return of(this.currentUser);
            })
          );
      })
    );

    // return new Promise((resolve, reject) => {
    //   this.http.post<any>(`${environment.API_ENDPOINT}login`, { id_user: username, password: password }).subscribe( token => {
    //     const helper = new JwtHelperService();
    //     let user = new User();
    //     user.id_user = username;
    //     user.token = token;
    //     user.payload = helper.decodeToken(user.token);
    
    //     if (this.currentUserValue){
    //       this.currentUserValue.token = token;
    //       this.currentUserValue.payload = helper.decodeToken(user.token);
    //     }

    //     // get user data
    //     const httpOptions = {
    //       headers: new HttpHeaders({ Authorization: `Bearer ${token}` })
    //     };
   
    //     this.http.get<User>(`${environment.API_ENDPOINT}users/${user.id_user}/show`, httpOptions ).subscribe( usr => {
    //         Object.assign(user, usr);

    //         if (user.user_addresses){
    //           user.user_addresses = user.user_addresses.map( address => new UserAddress(address));
    //         }
    //         user.user_addresses.forEach(address => {
    //             address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
    //         });

    //         // save to storage
    //         localStorage.setItem('currentUser', JSON.stringify(user));
    //         this.currentUserSubject.next(user);
    //         this.translate.use(user.language);
    //         this.toastr.success(this.translate.instant('LOGIN.LOGEDIN'));
    //         resolve(usr);
    //       }, error =>{
    //         reject(null);
    //       });   

    //     }, error =>{
    //       reject(error);
    //     });
    // });
  }

  logout() {
    if (this.isLogedUser) {
      let id_user = this.currentUserValue.id_user;
      let token = this.currentUserValue.token;
      
      this.clearStorage();
      this.currentUserSubject.next(null);
      //20250602 axa inici
      this.currentUserAxASubject.next(null);
      //20250602 axa final

      // remove user from local storage to log user out
      return this.http.post<any>(`${environment.API_ENDPOINT}logout`, { id_user: id_user },{ headers: { Authorization: 'Bearer ' + token }}).pipe(
        map ( success => {
          this.toastr.success(this.translate.instant('LOGIN.LOGEDOUT'));
          this.router.navigate(['/']);
          return success;
        }),
        catchError( error => {
          this.toastr.success(this.translate.instant('LOGIN.LOGEDOUT'));
          this.router.navigate(['/']); 
          return of(false);
        })
      );
    }
    return of(false);
  }

  refresh() {
    // console.log('auth.refresh');
    return this.http.get<User>(`${environment.API_ENDPOINT}users/${this.currentUserValue.id_user}/show`).pipe(
      concatMap ( usr => {
        // console.log('user refresh');
        let user = this.currentUserValue;
        (<any>Object).assign(user , usr);
        user.id_user = usr.id_user.toLowerCase();

        if (user.user_addresses){
          user.user_addresses = user.user_addresses.map( address => new UserAddress(address));
        }
        user.user_addresses.forEach(address => {
            address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
        });

        
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
        return this.currentUser;
      })
    );
  }


  public getAccessToken() : string{
    if (this.isLogedUser){
      return this.currentUserValue.token;
    }
    return null;
  }

  refreshAccessToken() : Observable<string> {

    // Try to refresh
    if (isDevMode){
      // console.log('Refrescant token...');
    }

    //20250602 axa inici
    // Los token AxA no se pueden refrescar
    if (this.isAxA) {
      return of(this.currentUserValue.token);
    }
    //20250602 axa inici

    
    return this.http.post<string>(`${environment.API_ENDPOINT}login/refresh`, {id_user : this.currentUserValue.id_user, password : ''}).pipe(
      tap( newToken => {
        // console.log('newToken inside ' + newToken)
        const helper = new JwtHelperService();
        this.currentUserValue.token = newToken;
        this.currentUserValue.payload = helper.decodeToken(newToken);
        localStorage.setItem('currentUser', JSON.stringify(this.currentUserValue));      
        //let user = this.currentUserValue;
        //const helper = new JwtHelperService();
        //user.token = newToken;
        //localStorage.setItem('currentUser', JSON.stringify(user));
        //this.currentUserSubject.next(user);
        return newToken;
      })
    );
    
  }
  

  private clearStorage(){
    localStorage.removeItem('currentUser');
    //20250602 axa inici
    localStorage.removeItem('currentUserAxA');
    //20250602 axa final
    localStorage.removeItem('currentBasketPrice'); 
    localStorage.removeItem('currentDelivery'); 
    localStorage.removeItem('currentBasket'); 
    sessionStorage.clear();
  }


  //20250602 axa inici
  //////////////////////////////////////////////
  //      COMPRA AXA                          //
  //////////////////////////////////////////////

  public get isAxA(): boolean {
    if (this.isLogedUser) return this.currentUserSubject.value.payload.nameid.startsWith('AxA');
    return false;
  }

  loginAxA(username: string, password: string) {
    return this.http.post<any>(`${environment.API_ENDPOINT}loginaxa`, { id_user: username.toLowerCase(), password: password }).pipe(
      concatMap((userAxA: UserAxA) => {
        userAxA.id_user = username.toLowerCase();
        this.translate.use(userAxA.custLanguage);
        localStorage.setItem('currentUserAxA', JSON.stringify(userAxA));
        userAxA = new UserAxA(userAxA);
        userAxA.user_AxA_addresses.forEach(address => {
          address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
        });
        this.currentUserAxASubject.next(userAxA);
        return this.currentUserAxA;
      })
    );
  }

  fullLoginAxA(userAxA: UserAxA, reservation: DeliveryReservation) {
    
    return this.http.post<any>(`${environment.API_ENDPOINT}loginaxa/${userAxA.temp_AxA_id}`, reservation).pipe(
      concatMap(token => {
        const helper = new JwtHelperService();
        let user = new User();
        user.id_user = userAxA.id_user.toLowerCase();
        user.token = token;
        user.payload = helper.decodeToken(user.token);
        

        // get user data
        const httpOptions = {
          headers: new HttpHeaders({ Authorization: `Bearer ${token}` })
        };

        return this.http.get<User>(`${environment.API_ENDPOINT}users/${user.id_user}/show`, httpOptions).pipe(
          concatMap(usrInfo => {
            Object.assign(user, usrInfo);
            user.id_user = usrInfo.id_user.toLowerCase();
            if (user.user_addresses) {
              user.user_addresses = user.user_addresses.map(address => new UserAddress(address));
            }
            user.user_addresses.forEach(address => {
              address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
            });

            // elimina useraxa
            localStorage.removeItem('currentUserAxA');
            this.currentUserAxASubject.next(null);

            // save to storage
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);

            this.translate.use(user.language);
            this.toastr.success(this.translate.instant('LOGIN.LOGEDIN'));
            return this.currentUser;
          })
        );
      }),
      // catchError( error => {
      //   console.log(error);
      //   return of(false);
      // })
    );
  }

  reloginAxA() {
    return this.http.patch<any>(`${environment.API_ENDPOINT}reloginaxa`, '').pipe(
      concatMap((userAxA: UserAxA) => {

        // guardamos el id_user actual
        userAxA.id_user = this.currentUserValue.id_user;

        // elimina el login de compra planificada
        this.clearStorage()
        this.currentUserSubject.next(null);

        // guarda el login de compra AxA
        localStorage.setItem('currentUserAxA', JSON.stringify(userAxA));
        userAxA = new UserAxA(userAxA);
        userAxA.user_AxA_addresses.forEach(address => {
          address.mapURL = this.dom.bypassSecurityTrustResourceUrl(`https://maps.google.com/maps?q=${address.addressing}&t=&z=17&ie=UTF8&iwloc=&output=embed`);
        });
        this.currentUserAxASubject.next(userAxA);
        return this.currentUserAxA;
      }),
      catchError(error => {
        this.toastr.error(this.translate.instant('LOGIN.RELOGINAXA_ERROR'));
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }


  relogin() {

    return this.http.patch<any>(`${environment.API_ENDPOINT}relogin`, '').pipe(
      concatMap(token => {
        const helper = new JwtHelperService();
        this.currentUserValue.token = token;
        this.currentUserValue.payload = helper.decodeToken(token);

        //this.clearStorage();
        //this.currentUserAxASubject.next(null); 

        // guarda el login de compra planificada
        localStorage.setItem('currentUser', JSON.stringify(this.currentUserValue));
        // borramos arbol para recargarlo
        sessionStorage.removeItem('categoriesAuthTree');
        // refrescamos usuario
        this.currentUserSubject.next(this.currentUserValue);
        return this.currentUser;
      }),
      catchError(error => {
        this.toastr.error(this.translate.instant('LOGIN.RELOGINAXA_ERROR'));
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }

  //20250602 axa final

}
